<template>
  <div>
    <div class="row">
      <div class="col-md-4">
        <h4>Logo da Empresa</h4>
        <span>Adicione o logotipo da sua empresa.</span>
        </div>
      <div class="col-md-8">
        <img class="profile-photo" :src="logo" />
        <span v-if="isUploadingPicture">Aguarde...</span>
        <a v-else href="#" v-on:click.stop.prevent="selectPhoto()" class="change-photo">Mudar imagem</a>
        <input ref="uploadBtn" class="input-photo" type="file" @change="uploadPhoto" />
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <h4>Dados da Empresa</h4>
        <span>Complete com os dados do seu negócio.</span>
      </div>
      <div class="col-md-8">
        <div class="profile-data">

          <div class="row">
            <div class="form-group col-sm">
              <label>Razão Social</label>
              <input type="text" class="form-control" name="fullname" placeholder="Informe a razão social da Empresa" v-model="legalname"/>
            </div>
          </div>

          <div class="row">
            <div class="form-group col-sm">
              <label>Nome Fantasia</label>
              <input type="text" class="form-control" name="fullname" placeholder="Informe o nome fantasia" v-model="fantasyname"/>
            </div>
          </div>

          <div class="row">
            <div class="form-group col-sm">
              <label>Link do Produto</label>
              <input type="text" class="form-control" name="fullname" placeholder="Informe o link do produto para venda" v-model="site"/>
            </div>
          </div>

          <div class="row">
            <div class="form-group col-sm">
              <label>CNPJ</label>
              <input type="text" class="form-control" name="fullname" placeholder="Informe o CNPJ da Empresa" v-model="cnpj"/>
            </div>
          </div>

          <div class="row">
            <div class="form-group col-sm">
              <label>E-mail para Contato</label>
              <input type="email" class="form-control" name="email" placeholder="Informe seu email" v-model="email"/>
            </div>
          </div>

          <div class="row">
            <div class="form-group col-sm">
              <label>Telefone</label>
              <input type="phone" class="form-control" name="phone" placeholder="(11) 99999-9999" v-model="phone"/>
            </div>
            <div class="form-group col-sm">
              <label>Responsável</label>
              <input type="phone" class="form-control" name="celphone" placeholder="Responsável pelo contato" v-model="responsible"/>
            </div>
          </div>

        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div v-if="showMsg" class="alert alert-danger alert-dismissible fade show" role="alert">
          {{msg}}
          <button type="button" class="close" data-dismiss="alert" aria-label="Fechar" v-on:click.stop.prevent="hideMessage()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div v-if="showSuccessMsg" class="alert alert-success alert-dismissible fade show" role="alert">
          {{successMsg}}
          <button type="button" class="close" data-dismiss="alert" aria-label="Fechar" v-on:click.stop.prevent="hideMessage()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <button class="btn submit" v-on:click.stop.prevent="save()">Salvar Dados</button>
      </div>
    </div>
  </div>
</template>

<script>
import auth from '../../services/auth'
import Functions from '../../utils/functions'
import { API } from '../../services/api'

export default {
  name: 'FormPartner',
  props: ['user'],
  data () {
    return {
      msg: "",
      showMsg: "",
      successMsg: "",
      showSuccessMsg: "",
      partner: null,
      legalname: null,
      fantasyname: null,
      site: null,
      cnpj: null,
      email: null,
      phone: null,
      responsible: null,
      logo: 'https://via.placeholder.com/500x500',
      isUploadingPicture: false
    }
  },
  created(){
    this.loadUserData();
  },
  methods: {
    loadUserData(){
      this.partner = this.user ? this.user.Partner : null;
      if(this.partner){
        this.legalname = this.partner.legalname;
        this.fantasyname = this.partner.fantasyname;
        this.site = this.partner.site;
        this.cnpj = this.partner.cnpj;
        this.email = this.partner.email;
        this.phone = this.partner.phone;
        this.responsible = this.partner.responsible;
      }
      this.logo = (this.partner && this.partner.logo) ? this.partner.logo : 'https://via.placeholder.com/500x500';
    },
    save(){
      this.$emit('showloading');
      if(this.validate()){
        this.$http.post(API.Profile.partnerUpdate, {
          legalname: this.legalname,
          email: this.email,
          phone: this.phone,
          celphone: this.celphone,
          fantasyname: this.fantasyname,
          site: this.site,
          cnpj: this.cnpj,
          responsible: this.responsible,
          logo: this.logo,
          formType: 'updatePartner'
        }, {headers: auth.getHeaders()}).then((response) => {
          if(response.body.success == true){
            this.successMsg = response.body.message;
            this.showSuccessMsg = true;
          }else{
            this.msg = response.body.message;
            this.showMsg = true;
          }
          this.password = null;
          this.newPassword = null;
          this.newPasswordConfirm = null;
          this.$emit('hideloading');
        }, (error) => {
          console.log(error)
        });
      }else{
        this.$emit('hideloading');
      }
    },
    selectPhoto(){
      this.$refs.uploadBtn.click();
    },
    uploadPhoto(e){
      e.preventDefault();
      this.isUploadingPicture = true;
      var file = e.target.files[0]
      var reader = new FileReader();
      var $this = this;
      reader.addEventListener('loadend', (e) => {
        $this.$http.post(API.Profile.partnerUpdate, {uploadLogo: true, fileName: file.name, fileType: file.type, formType: 'uploadLogo'}, {headers: auth.getHeaders()})
        .then((res) => {
          return $this.$http.put(res.body.uploadUrl, new Blob([reader.result], {type: file.type}), {headers: {'Content-Type': file.type, 'x-amz-acl': 'authenticated-read'}});
        })
        .then((res) => {
          var logo = res.url.split('?');
          $this.isUploadingPicture = false;
          $this.logo = logo[0];
        })
      })
      reader.readAsArrayBuffer(file);
    },
    validate(){
      if(this.legalname == '' || this.legalname == null){
        this.showMessage("Insira o nome legal da sua loja.");
        return false;
      }
      if(this.fantasyname == '' || this.fantasyname == null){
        this.showMessage("Insira o nome fantasia da sua loja.");
        return false;
      }
      if(this.site == '' || this.site == null){
        this.showMessage("Insira o link do produto no site da loja.");
        return false;
      }
      if(this.email == '' || this.email == null){
        this.showMessage("Insira um e-mail válido.");
        return false;
      }
      if(!Functions.validateEmail(this.email)){
        this.showMessage("E-mail inválido. Insira um e-mail no formato correto.");
        return false;
      }
      return true;
    },
    showMessage(msg){
      this.msg = msg;
      this.showMsg = true;
    },
    hideMessage(){
      this.successMsg = "";
      this.msg = "";
      this.showMsg = false;
      this.showSuccessMsg = false;
    }
  },
  watch: {
    user: function(newVal, oldVal) {
      this.loadUserData();
    }
  }
}
</script>

<style lang="scss" scoped>
.input-photo{
  display: none;
}
.form-partner{
    margin-top: 20px;
    .row{
      padding: 20px;
      border-bottom: thin solid #eee;
      &:last-child{
        border-bottom: none;
      }
    }

    .profile-photo{
      width: 150px;
      height: 150px;
    }

    .change-photo{
      text-decoration: none;
      color: #333;
      margin-left: 20px;
    }

    .profile-data{
      .row{
        padding: 0px;
        border-bottom: none;
      }
    }

    .submit{
      font-size: 22px;
      color: #fff;
      background-color: #00AE39;
      &:hover{
        background-color: #aaa;
        color: #333;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/profile/FormPartner.vue